import styled from 'styled-components';

export const ScheduleContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const DatetimeContainer = styled.div`
  display: flex;
  & > div:last-child {
    margin-left: 10px;
  }
  & > * {
    flex: 1;
  }
`;
